import * as yup from "yup";
import { BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE } from ".";
import { getPhoneValidation } from "constants/validate";

const ValidateSchema = (t, roleMode) => {
  const ruleOnlyAdminRole = {
    from_hub: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("label.receive_hub_id"),
        })
      )
      .nullable(),

    sale: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("label.sale"),
        })
      )
      .nullable(),
  };

  const rules = {
    customer: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("label.customer_id"),
        })
      )
      .nullable(),

    test_pack: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("label.test_pack"),
        })
      )
      .nullable(),

    detail_address: yup.string().required(
      t("message.enter_required", {
        target: t("label.delivery_address"),
      })
    ),

    province_code: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("placeholder.province"),
        })
      )
      .nullable(),

    // district_code: yup
    //   .object()
    //   .required(
    //     t("message.select_required", {
    //       target: t("placeholder.district"),
    //     })
    //   )
    //   .nullable(),

    ward_code: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("placeholder.ward"),
        })
      )
      .nullable(),

    customer_name: yup.string().required(
      t("message.enter_required", {
        target: t("placeholder.customer_name"),
      })
    ),

    phone: yup
      .string()
      .nullable()
      .required(t("form.validate.required", { title: t("form.phone") }))
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),

    payment_method: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("label.payment_method"),
        })
      )
      .nullable(),

    action_date: yup
      .string()
      .required(
        t("message.select_required", {
          target: t("label.action_date"),
        })
      )
      .nullable(),

    timeslot: yup
      .object()
      .required(
        t("message.select_required", {
          target: t("label.timeslot"),
        })
      )
      .nullable(),

    ...(roleMode === BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE.ADMIN
      ? ruleOnlyAdminRole
      : {}),
  };

  return yup.object().shape(rules);
};

export default ValidateSchema;
